import { Directive, HostListener, inject } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: 'input[redispatchNullValue]',
    standalone: false,
})
export class DefaultNullValueDirective {

    private control = inject(NgControl);

    @HostListener('input', [
        '$event.target',
    ])
    onEvent(target: HTMLInputElement) {
        this.control.viewToModelUpdate((target.value === '') ? null : target.value);
    }
}
